import request from '.';

export default function signVerification(data) {

    return request({
        url: 'v1/contractCenter/signVerification',
        method: 'post',
        data,
    });
}
